import { MenuItem } from "primeng/api";

export class Tool {
  key: string;
  label: string;
  type: string;

}

export class RowTools {
  tools: Tool[] = [];

   

  get width(): number {
    let sum = 0;

    if (this.tools == null || this.tools.length == 0)
      return 0;

    
    this.tools.forEach(t => {
      sum += (t.type == 'kebob' ? 1 : 0) * 35;
      sum += (t.type == 'link' ? 1 : 0) * 47;
    });

    return sum + 8;
  }

  get hasLink(): boolean {
    return this.tools.findIndex(t => t.type == 'link') != -1;
  }

  get hasKebob(): boolean {
    return this.tools.findIndex(t => t.type == 'kebob') != -1;
  }

  get links(): Tool[] {
    return this.tools.filter(t => t.type == 'link');
  }

  get kebob(): MenuItem[] {
    return this.tools
      .filter(t => t.type == 'kebob')
      .map(t => {
        return {
          id: t.key,
          label: t.label
        }
      });

  }

  clearTools() {
    this.tools = [];
  }

  addKebob(key: string, label: string) {
    let kebob = new Tool();
    kebob.key = key;
    kebob.type = 'kebob';
    kebob.label = label;

    this.tools.push(kebob);
  }

  addLink(key: string, label: string) {
    let link = new Tool();
    link.key = key;
    link.type = 'link';
    link.label = label;

    this.tools.push(link);
  }

}

export class RowToolEvent {
  key: string;
  tool: Tool;
  item: any = null;
}
